module.exports = {"resourceQuery":"?resourcequery","query":"?query","prev":"module.exports = \"a\";"}


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/query/loaders/queryloader.js?query!./loaders/query/a.js?resourcequery
 ** module id = 3
 ** module chunks = 0
 **/